import LegalLayout from './LegalLayout';

const PolitiqueConfidentialite = () => {
  return (
    <LegalLayout
      title="Politique de confidentialité"
      description="Politique de confidentialité d'AlloRéparations Montpellier — données personnelles, cookies, RGPD et droits des utilisateurs."
      lastUpdated="27 avril 2026"
    >
      <section data-testid="section-introduction">
        <h2>1. Introduction</h2>
        <p>
          AlloRéparations attache une importance particulière à la protection de vos données personnelles
          et au respect de votre vie privée. La présente politique de confidentialité vous informe sur la
          manière dont nous collectons, utilisons et protégeons vos données dans le cadre de l'utilisation
          du site <strong>www.alloreparations.com</strong> et de nos services en boutique.
        </p>
        <p>
          Elle est conforme au Règlement Général sur la Protection des Données (RGPD — règlement UE
          2016/679) et à la loi française n°78-17 du 6 janvier 1978 modifiée (Informatique et Libertés).
        </p>
      </section>

      <section data-testid="section-responsable">
        <h2>2. Responsable du traitement</h2>
        <p>
          Le responsable du traitement des données personnelles est&nbsp;:
        </p>
        <ul>
          <li><strong>AlloRéparations</strong></li>
          <li>7 place des Martyrs de la Résistance, 34000 Montpellier</li>
          <li>Téléphone&nbsp;: <a href="tel:+33983820754">09 83 82 07 54</a></li>
          <li>Email&nbsp;: <a href="mailto:alloreparations@gmail.com">alloreparations@gmail.com</a></li>
        </ul>
      </section>

      <section data-testid="section-donnees-collectees">
        <h2>3. Données collectées</h2>
        <p>
          Nous collectons uniquement les données strictement nécessaires aux finalités décrites
          ci-dessous&nbsp;:
        </p>
        <h3>3.1 Données collectées via le formulaire de devis et le formulaire de contact</h3>
        <ul>
          <li>Nom et prénom</li>
          <li>Adresse email</li>
          <li>Numéro de téléphone</li>
          <li>Modèle de l'appareil et nature de la panne</li>
          <li>Tout message ou information communiqué volontairement</li>
        </ul>
        <h3>3.2 Données collectées en boutique lors d'une réparation</h3>
        <ul>
          <li>Nom, prénom et coordonnées de contact</li>
          <li>Modèle, IMEI ou numéro de série de l'appareil</li>
          <li>Description de la panne et historique d'intervention</li>
          <li>Pièce d'identité (lors d'un rachat de téléphone, sans conservation de la copie)</li>
        </ul>
        <h3>3.3 Données techniques collectées automatiquement</h3>
        <ul>
          <li>Adresse IP, type de navigateur, système d'exploitation, fournisseur d'accès</li>
          <li>Pages consultées, durée de la visite, pages de provenance</li>
          <li>Identifiants de cookies (voir section 7)</li>
        </ul>
      </section>

      <section data-testid="section-finalites">
        <h2>4. Finalités et bases légales</h2>
        <table>
          <thead>
            <tr>
              <th>Finalité</th>
              <th>Base légale</th>
              <th>Durée de conservation</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Traitement d'une demande de devis ou de contact</td>
              <td>Mesures précontractuelles à la demande du Client (art. 6.1.b RGPD)</td>
              <td>3 ans à compter du dernier contact</td>
            </tr>
            <tr>
              <td>Exécution d'une réparation ou d'une vente</td>
              <td>Exécution du contrat (art. 6.1.b RGPD)</td>
              <td>10 ans (obligations comptables — art. L.123-22 Code de commerce)</td>
            </tr>
            <tr>
              <td>Gestion de la garantie après-vente</td>
              <td>Exécution du contrat (art. 6.1.b RGPD)</td>
              <td>Durée de la garantie + 2 ans</td>
            </tr>
            <tr>
              <td>Statistiques de fréquentation du site</td>
              <td>Intérêt légitime (art. 6.1.f RGPD) ou consentement</td>
              <td>13 mois maximum</td>
            </tr>
            <tr>
              <td>Newsletter ou communication commerciale (le cas échéant)</td>
              <td>Consentement (art. 6.1.a RGPD)</td>
              <td>3 ans à compter du dernier contact ou jusqu'à désinscription</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section data-testid="section-destinataires">
        <h2>5. Destinataires des données</h2>
        <p>
          Vos données sont traitées par les seuls collaborateurs habilités d'AlloRéparations. Elles peuvent
          être communiquées à&nbsp;:
        </p>
        <ul>
          <li>Notre hébergeur (pour le stockage technique du site)</li>
          <li>Notre prestataire de paiement (en cas de paiement à distance)</li>
          <li>Les autorités administratives ou judiciaires en cas d'obligation légale</li>
        </ul>
        <p>
          <strong>Aucune donnée n'est vendue ou cédée à des tiers à des fins commerciales.</strong> Nos
          prestataires sont contractuellement engagés à respecter la confidentialité de vos données et à
          les traiter conformément au RGPD.
        </p>
      </section>

      <section data-testid="section-transfert">
        <h2>6. Transfert hors de l'Union européenne</h2>
        <p>
          Nous privilégions des prestataires situés au sein de l'Union européenne. Si un transfert de
          données hors UE devait avoir lieu (notamment via certains outils statistiques), il serait
          encadré par les clauses contractuelles types de la Commission européenne ou par tout autre
          mécanisme garantissant un niveau de protection équivalent.
        </p>
      </section>

      <section data-testid="section-cookies">
        <h2>7. Cookies</h2>
        <p>
          Le site www.alloreparations.com utilise des cookies pour assurer son bon fonctionnement et,
          avec votre accord, mesurer son audience. Lors de votre première visite, un bandeau vous
          permet d'<strong>accepter</strong>, <strong>refuser</strong> ou <strong>personnaliser</strong>
          chaque catégorie. Refuser est aussi simple qu'accepter, conformément aux recommandations de
          la CNIL.
        </p>
        <h3>Types de cookies utilisés</h3>
        <ul>
          <li>
            <strong>Strictement nécessaires&nbsp;:</strong> indispensables au fonctionnement du site
            (mémorisation de votre choix de cookies, sécurité). Ils ne peuvent pas être désactivés et
            ne nécessitent pas de consentement.
          </li>
          <li>
            <strong>Mesure d'audience&nbsp;:</strong> nous aident à comprendre comment vous utilisez
            le site (pages consultées, durée de visite). Désactivés par défaut. Activés uniquement
            avec votre consentement explicite.
          </li>
          <li>
            <strong>Personnalisation&nbsp;:</strong> mémorisent vos préférences d'affichage pour
            vous offrir une expérience adaptée lors de votre prochaine visite. Désactivés par défaut.
            Activés uniquement avec votre consentement explicite.
          </li>
        </ul>
        <h3>Modifier ou retirer votre consentement</h3>
        <p>
          Vous pouvez à tout moment modifier vos choix en cliquant sur le lien
          <strong>«&nbsp;Gérer mes cookies&nbsp;»</strong> en bas de page. Vous pouvez également
          paramétrer ou supprimer les cookies directement dans les options de votre navigateur.
        </p>
        <p>
          Votre choix est conservé pendant <strong>13 mois</strong>. Au-delà, le bandeau de
          consentement réapparaît automatiquement.
        </p>
      </section>

      <section data-testid="section-droits">
        <h2>8. Vos droits</h2>
        <p>
          Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants
          sur vos données personnelles&nbsp;:
        </p>
        <ul>
          <li><strong>Droit d'accès&nbsp;:</strong> obtenir la confirmation que vos données sont traitées et en recevoir une copie</li>
          <li><strong>Droit de rectification&nbsp;:</strong> corriger des données inexactes ou incomplètes</li>
          <li><strong>Droit à l'effacement («&nbsp;droit à l'oubli&nbsp;»)&nbsp;:</strong> demander la suppression de vos données dans les cas prévus par la loi</li>
          <li><strong>Droit à la limitation&nbsp;:</strong> restreindre le traitement de vos données</li>
          <li><strong>Droit d'opposition&nbsp;:</strong> vous opposer au traitement pour des motifs légitimes</li>
          <li><strong>Droit à la portabilité&nbsp;:</strong> récupérer vos données dans un format structuré</li>
          <li><strong>Droit de retirer votre consentement&nbsp;:</strong> à tout moment, sans remettre en cause les traitements antérieurs</li>
          <li><strong>Droit de définir des directives post-mortem&nbsp;:</strong> sur le sort de vos données après votre décès</li>
        </ul>
        <p>
          Pour exercer ces droits, contactez-nous&nbsp;:
        </p>
        <ul>
          <li>Par email&nbsp;: <a href="mailto:alloreparations@gmail.com">alloreparations@gmail.com</a></li>
          <li>Par courrier&nbsp;: AlloRéparations — 7 place des Martyrs de la Résistance, 34000 Montpellier</li>
        </ul>
        <p>
          Nous vous répondrons dans un délai d'<strong>un mois</strong>. Une preuve d'identité pourra
          vous être demandée en cas de doute raisonnable sur l'identité du demandeur.
        </p>
      </section>

      <section data-testid="section-reclamation">
        <h2>9. Droit de réclamation</h2>
        <p>
          Si vous estimez, après nous avoir contactés, que vos droits ne sont pas respectés, vous pouvez
          adresser une réclamation à la <strong>CNIL</strong>&nbsp;:
        </p>
        <ul>
          <li>En ligne&nbsp;: <a href="https://www.cnil.fr/fr/plaintes" target="_blank" rel="noopener noreferrer">www.cnil.fr/fr/plaintes</a></li>
          <li>Par courrier&nbsp;: CNIL — 3 place de Fontenoy, TSA 80715, 75334 Paris cedex 07</li>
        </ul>
      </section>

      <section data-testid="section-securite">
        <h2>10. Sécurité des données</h2>
        <p>
          Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger
          vos données personnelles contre la perte, l'altération, la diffusion ou l'accès non autorisé&nbsp;:
          chiffrement des connexions (HTTPS), restriction des accès, sauvegardes régulières, formation du
          personnel.
        </p>
      </section>

      <section data-testid="section-modification">
        <h2>11. Modification de la politique</h2>
        <p>
          La présente politique de confidentialité peut être amenée à évoluer pour s'adapter aux évolutions
          légales, techniques ou opérationnelles. Toute modification substantielle vous sera notifiée par
          un moyen adapté. La version en vigueur est consultable en permanence sur cette page.
        </p>
      </section>
    </LegalLayout>
  );
};

export default PolitiqueConfidentialite;
